import { colors, Table, TableHeader, TableHeading, TableRow } from '@insurancemenu/imenu-components-lib';
import { TABLE_HEADER_BG_COLOR } from '@insurancemenu/imenu-components-lib/dist/components/tables/utils/constants';
import { boxShadows } from '@insurancemenu/imenu-components-lib/dist/utils';
import styled from 'styled-components';

export const ContentStyled = styled.div`
  padding-bottom: 5rem;
`;

export const TableWrapperStyled = styled.div`
  background-color: ${colors.neutral.white};
  border-radius: 1rem;
  margin-bottom: 5rem;
  padding-bottom: 1rem;
  overflow: hidden;
  box-shadow: ${boxShadows.dark[4]};
`;

export const TemplateTableStyled = styled(Table)`
  width: max(100%, 140rem);
`;

export const TableHeaderStyled = styled(TableHeader)`
  box-sizing: border-box;
`;

export const TableHeadingStyled = styled(TableHeading)`
  padding: 1.6rem 1rem;
  background-color: ${TABLE_HEADER_BG_COLOR};

  &:first-child {
    padding-left: 2rem;
    padding-right: 2rem;
  }

  &:last-child {
    padding-right: 2rem;
  }
`;

export const HeadingsRowStyled = styled(TableRow)`
  border-top: 0.1rem solid ${colors.neutral[500]};
`;

export const FilterBarStyled = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 2rem;
  margin-bottom: 5rem;
`;

export const FilterSectionStyled = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 2rem;
  align-items: flex-end;
  justify-content: flex-start;
`;
